import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import { processLink } from '../../shared/processLink';
import { ReachButton } from '../ReachButton/ReachButton';
import { ParentNodeProvider } from '../../providers/ParentNodeProvider';
import { AccentedText } from '../AccentedText/AccentedText';

export interface ThreeColumnNarrowColumnProps {
    image?: {
        blueLine: IGatsbyImageData;
        whiteSticker: IGatsbyImageData;
        blueSticker: IGatsbyImageData;
    };
    bg?: `white` | `gray` | `dark`;
    heading?: string;
    text?: string;
    link?: {
        title: string;
        uri: string;
    };
}

export const ThreeColumnNarrowColumn = (
    props: ThreeColumnNarrowColumnProps
) => {
    let image: IGatsbyImageData;
    if (props.image) {
        if (props.bg === `white`) {
            image = props.image.whiteSticker;
        } else if (props.bg === `dark`) {
            image = props.image.blueSticker;
        } else {
            image = props.image.blueLine;
        }
    }

    return (
        <ParentNodeProvider
            nodeName={props.heading}
            nodeType="Three_Column_Narrow"
        >
            <div
                className={`column ${
                    props.heading && props.text && !image ? `small` : `large`
                }`}
            >
                {props.heading && (
                    <h3>
                        <AccentedText>{props.heading}</AccentedText>
                    </h3>
                )}
                {props.text && (
                    <div
                        className="text"
                        dangerouslySetInnerHTML={{
                            __html: props.text,
                        }}
                    ></div>
                )}
                {props.link && (
                    <div className="buttons">
                        <ReachButton
                            href={processLink(props.link.uri)}
                            buttonStyle="borderless"
                            buttonIcon={{
                                icon: `ki-arrow-right`,
                                position: `right`,
                            }}
                        >
                            {props.link.title}
                        </ReachButton>
                    </div>
                )}
                {image && (
                    <div className="img">
                        <GatsbyImage image={image} alt="" />
                    </div>
                )}
            </div>
        </ParentNodeProvider>
    );
};
